(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/info-pair-amount.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/info-pair-amount.js');
'use strict';

const InfoPairAmount = _ref => {
  let {
    title,
    amount,
    isBold = false,
    isColor = false
  } = _ref;
  let style = '';
  if (isColor) {
    style = parseInt(amount, 10) > 0 ? 'fc-green' : 'fc-red';
  }
  if (isBold) {
    style += ' f-bold';
  }
  return React.createElement("span", null, title, ': ', React.createElement("span", {
    className: style
  }, svs.utils.format.Currency(amount), ' kr'));
};
svs.arena.pages.teams.components.InfoPairAmount = InfoPairAmount;

 })(window);